import { render, staticRenderFns } from "./sendMsg.vue?vue&type=template&id=031c5a9e&scoped=true"
import script from "./sendMsg.vue?vue&type=script&lang=js"
export * from "./sendMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c5a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031c5a9e')) {
      api.createRecord('031c5a9e', component.options)
    } else {
      api.reload('031c5a9e', component.options)
    }
    module.hot.accept("./sendMsg.vue?vue&type=template&id=031c5a9e&scoped=true", function () {
      api.rerender('031c5a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/lists/sendMsg.vue"
export default component.exports